<template>
  <div class='footer'>
    Copyright © 2019 无锡乐骐科技股份有限公司 |  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402001005">苏公网安备 32021402001005号</a> <a target="_blank" href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action">苏ICP备14019013号-8</a>
  </div>
</template>

<script>
    export default {
        name: "PhotoMakeFooter"
    }
</script>

<style scoped>
  .footer{
    position: absolute;
    bottom: 0;
    font-size:12px;
    color:rgba(102,102,102,1);
    height: 6%;
    display: flex;
    align-items: center;
    /*background:rgba(249,249,249,1);*/
    justify-content: center;
    width: 100%;
    background-color: #FFFFFF;
  }
</style>
